import React from 'react';

import type { UUID } from '@aline/common';
import { PlaybookDetailPanel } from 'src/editor/toolbars/right-panel/ai/playbooks';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    overflowY: 'auto',
  },
});

/**
 * The drill-in behind a playbook run card in a chat thread: the same detail
 * panel the Playbooks drawer shows, hosted inside the chat panel. Without an
 * editor mounted alongside (a chat host with no document open) the panel
 * still renders the run, but cannot materialize accepts or judge staleness
 * until the document is opened.
 */
export function ChatPlaybookRunPanel({
  documentId,
  onBack,
  playbookId,
}: {
  documentId: UUID;
  onBack: () => void;
  playbookId: UUID;
}): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <PlaybookDetailPanel documentId={documentId} playbookId={playbookId} onBack={onBack} />
    </div>
  );
}
